import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

type Props = {
    accountIds: number[],

    showAddToAccountTeam: boolean,
    openAddToAccountTeamTool: () => void,

    showRemoveFromAccountTeam: boolean,
    openRemoveFromAccountTeamTool: () => void,

    showSetAccountStatus: boolean,
    openSetAccountStatusTool: () => void,

    showUpdateLicense: boolean,
    openEnableModuleAccessPermissionsTool: () => void,
    openDisableModuleAccessPermissionsTool: () => void,
};

export const ToolsRow = (props: Props) => (
    <Group>
        {props.showAddToAccountTeam || props.showRemoveFromAccountTeam ? (
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>Update Account Team</b>
                    </FlatButton>
                )}>
                {props.showAddToAccountTeam ? (
                    <DropdownMenuItem
                        caption="Add To Account Team"
                        onClick={props.openAddToAccountTeamTool}
                    />
                ) : null}
                {props.showRemoveFromAccountTeam ? (
                    <DropdownMenuItem
                        caption="Remove From Account Team"
                        onClick={props.openRemoveFromAccountTeamTool}
                    />
                ) : null}
            </DropdownMenu>
        ) : null}
        {props.showSetAccountStatus ? (
            <FlatButton onClick={props.openSetAccountStatusTool}>
                <b>Set Account Status</b>
            </FlatButton>
        ) : null}
        {props.showUpdateLicense ? (
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>Update License</b>
                    </FlatButton>
                )}>
                <DropdownMenuItem
                    caption="Enable Module Access Permissions"
                    onClick={props.openEnableModuleAccessPermissionsTool}
                />
                <DropdownMenuItem
                    caption="Disable Module Access Permissions"
                    onClick={props.openDisableModuleAccessPermissionsTool}
                />
            </DropdownMenu>
        ) : null}
    </Group>
);
